module.exports = __webpack_public_path__ + "img/Porto Apartment - 42 of 85.7ced40e2.jpeg";